import { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import Boxes from "./Boxes";
import Controls from "./Controls";
import PieChart from "./PieChart";
import Table from "./Table";

import SuperAdminStatsSkeleton from "../../../components/skeletons/SuperAdminStatsSkeleton";
import { useGetAdminStatsQuery } from "../statisticsApiSlice";

const SuperAdminStats = ({ companyId }) => {
	const [yearRange, setYearRange] = useState();

	const [weightValues, setWeightValues] = useState({ from: "", to: "" });
	const onWeightChange = (e, type) => {
		e.preventDefault();

		if (type === "from") {
			setWeightValues({ ...weightValues, from: e.target.value });
		} else {
			setWeightValues({ ...weightValues, to: e.target.value });
		}
	};

	const [filterValues, setFilterValues] = useState({
		company: companyId,
		range: "",
		weightFrom: "",
		weightTo: "",
	});
	const [isRefetching, setIsRefetching] = useState(false);

	const {
		data: stats,
		error,
		isLoading,
		refetch,
	} = useGetAdminStatsQuery(filterValues);

	useEffect(() => {
		setIsRefetching(false);
	}, [stats, error]);

	const handleSubmit = async () => {
		setIsRefetching(true);
		const parsedRange = yearRange
			? [yearRange.startYear, yearRange.endYear]
			: "";

		if (
			filterValues.range === encodeURIComponent(parsedRange) &&
			filterValues.weightFrom === weightValues.from &&
			filterValues.weightTo === weightValues.to
		) {
			await refetch();
			return;
		}

		setFilterValues({
			company: companyId,
			range: encodeURIComponent(parsedRange),
			weightFrom: weightValues.from,
			weightTo: weightValues.to,
		});
	};

	if (isLoading) {
		return <SuperAdminStatsSkeleton />;
	}

	return (
		<Box>
			<Grid container spacing={5}>
				<Grid size={12}>
					<Controls
						yearRange={yearRange}
						setYearRange={setYearRange}
						weightFrom={weightValues.from}
						weightTo={weightValues.to}
						onWeightFromChange={(e) => onWeightChange(e, "from")}
						onWeightToChange={(e) => onWeightChange(e, "to")}
						onSubmit={handleSubmit}
						isLoading={isRefetching}
					/>
				</Grid>
				<Grid size={12}>
					<Table data={stats.perMonth} />
				</Grid>

				<Grid size={6}>
					<Boxes data={stats.summary} />
				</Grid>
				<Grid size={6}>
					<PieChart data={stats.channelsData} />
				</Grid>
			</Grid>
		</Box>
	);
};

export default SuperAdminStats;
